module.exports = __webpack_public_path__ + "img/folder-symlink.0bcd2523.svg";